import React from 'react'
import SearchPicker from '../common/SearchPicker'

const CollectionPicker = (props) => {

    const { state } = props

    const option = (collection) =>
        <div>
            <label className='block'>Ürün Kodu : {collection.code} </label>
            <label className='block mb-1'>Ürün Adı : {collection.name} </label>
        </div>

    return (
        <SearchPicker
            {...props}
            value={state ? `${state?.code}, ${state?.name}` : ""}
            option={(collection) => option(collection)}
        />
    )
}

export default CollectionPicker